var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.executePluginCommand = void 0;
__exportStar(require("./languageService"), exports);
var language_service_1 = require("@volar/language-service");
Object.defineProperty(exports, "executePluginCommand", { enumerable: true, get: function () { return language_service_1.executePluginCommand; } });
__exportStar(require("./ideFeatures/nameCasing"), exports);
__exportStar(require("./types"), exports);
//# sourceMappingURL=index.js.map